import { numberFormat } from './numberFormat';
import { rtrim } from './rtrim';

function handleSmallNumbers(numb: number): string {
  const str = numberFormat(numb, numb < 0.005 ? 5 : 9, '.', '');

  let result = '0.';
  let countSignificant = 0;

  for (let i = 2; i < str.length; i++) {
    result += str[i];
    if (str[i] !== '0') countSignificant++;
    if (str[i] === '0' && countSignificant === 1) countSignificant++;
    if (countSignificant >= 9) break;
  }

  return rtrim(result, '0').replace(/\.$/, '');
}

export function formatNumber(numb: number): string {
  if (Math.abs(numb) < 1e-9 || numb < 0.000005 || numb === 0) {
    return rtrim(numb.toFixed(9), '0').replace(/\.$/, '');
  }

  if (numb >= 1) {
    let rounded = numberFormat(numb, 2, '.', '');
    const decimalPart = rounded.split('.')[1];

    if (decimalPart && parseFloat(`0.${decimalPart}`) >= 0.99) {
      rounded = Math.round(numb).toString();
    }

    return rounded.includes('.') ? rtrim(rounded, '0').replace(/\.$/, '') : rounded;
  }

  return handleSmallNumbers(numb);
}
